// Imports


// Plugins
const plugins = [{
  location: "/app",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins